<template>
  <div class="inline-addon-card d-block d-md-flex">
    <div class="addon-card-title  d-block d-sm-flex align-items-center">
      <div class="d-block d-sm-flex align-items-center">
        <span class="text-nowrap">{{ getTranslatedInfo(addon) || addon.slug }}</span>
        <span
          v-if="isBranchBased"
          class="text-normal text-small"
        >&nbsp;({{ $t('subscription.for-current-branch-only') }})</span>
      </div>
      <div
        v-if="addon.countable || $store.getters['purchase/isAddonHasCount'](addon.slug) || $store.getters['purchase/isAddonHasCount'](addon.category)"
        class="d-flex align-items-center ml-0 ml-md-1"
      >
        <feather-icon
          icon="XIcon"
          size="12"
          class="mr-1"
        />
        <b-form-spinbutton
          v-model="addon.count"
          placeholder="qty"
          min="1"
          :max="addonCountMax || undefined"
          class="addon-limit"
        />
      </div>
    </div>
    <div class="d-none d-sm-block addon-card-divider" />
    <div class="addon-card-price">
      {{ $currencyFormat((addon.count || 1) * addon.price, 0) }}
    </div>
  </div>
</template>

<script>
import { BFormSpinbutton } from 'bootstrap-vue'

export default {
  name: 'InlineAddonCard',
  components: { BFormSpinbutton },
  inject: ['getTranslatedInfo'],
  props: {
    addon: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    isBranchBased() {
      return ['branded_domain', 'google'].includes(this.addon.slug)
    },
    addonCountMax() {
      return this.$store.getters['purchase/addonCountMax'](this.addon.slug)
    },
  },
}
</script>

<style lang="scss">
.inline-addon-card {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.75;
  color: var(--secondary);
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  background-color: #ffffff;

  padding: 15px 30px 15px 30px;
  border-radius: 6px;
  box-shadow: 0 4px 48px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #efefed;

  .addon-limit {
    max-width: 120px;
    text-align: center!important;
  }

  body.dark-layout & {
    background-color: var(--theme-dark-body-bg);
    color: #fafafa;
    &-divider {
      border-color: #fafafa;
    }
  }

  &-title {
    flex-grow: 0;
  }

  &-divider {
    flex-grow: 1;
    height: 1px;
    width: 100%;
    border-top: solid 1px #d8d6de;
    margin: 0 13.5px;
  }

  &-price {
    flex-grow: 0;
  }

  .addon-card-divider {
    height: 1px;
    margin: 6px 12px 0 12px;
    flex-grow: 1;
    border-top: 1px solid var(--description-color);
  }
}
</style>
